import { getAxiosBackendApi } from "../helpers/axios"

class EmployeeServices{

    constructor(){
    }

    addEmployee(data){
        return getAxiosBackendApi().post('employees', data)
    }
}

export default new EmployeeServices()